export { default as Thanks } from './Thanks';
